import { render } from "./HomeReview.vue?vue&type=template&id=54db1b2e&scoped=true"
import script from "./HomeReview.vue?vue&type=script&lang=js"
export * from "./HomeReview.vue?vue&type=script&lang=js"

import "./HomeReview.vue?vue&type=style&index=0&id=54db1b2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54db1b2e"]])

export default __exports__